module.exports = __webpack_public_path__ + "static/media/DNase_Free_Water.ac3b0393.svg";